export default __webpack_public_path__ + "static/media/2021-04-21_OBA_IDY_seatbelt_machine-008-6500x4500px.96fc4b03.jpg";